import React from "react";

export const ActionPlan = () => (
  <>
    <div className="hero">
      <h1>Action Plan</h1>
    </div>
    <section className="hero is-fullheight mb-5">
      <div className="columns">
        <div className="column is-one-quarter fadeLeftMini"></div>
        <div className="column fadeLeftMini">
          <p>
            Phase 1 (Completed): Business launch mid-2023, established 
            major retail partnership, developed service portfolio (£25-£330 range), 
            secured automotive dealer relationships, initiated fuel retailer negotiations.
          </p>
          <p>
            Phase 2 (Current Focus): Scale operations with investment capital, 
            expand service capacity, finalize fuel retailer partnership agreement, 
            develop additional B2B contracts, enhance operational efficiency.
          </p>
          <p>
            Phase 3 (Investment-Dependent): Market expansion beyond Surrey & 
            Greater London, franchise model development, technology integration, 
            additional partnership development leveraging proven business model.
          </p>{" "}
          <button
            className="button is-pulled-right btn"
            title="Action Plan"
            onClick={(event) => (window.location.href = "/ExecutiveAction")}
          >
            <span>Action Plan</span>
          </button>
        </div>
        <div className="column is-one-quarter fadeLeftMini"></div>
      </div>
    </section>
  </>
);
